module.exports = __webpack_public_path__ + "img/1437743864.32a5a790.jpg";